exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Tooltips-18884e6a{position:relative}\n", ""]);

// Exports
exports.locals = {
	"Tooltips": "Tooltips-18884e6a"
};